import _PlaylistPlayRounded from "@mui/icons-material/PlaylistPlayRounded";
import React from 'react';
import { ButtonContainer, getShadowIconStyles, IconButtonLabel, IconButtonWrapper } from 'app/components/tv/customControls/SharedCustomControlsStyles';
export const PlaylistToggle = _ref => {
  let {
    onClick
  } = _ref;
  return /*#__PURE__*/React.createElement(IconButtonWrapper, {
    "data-sentry-element": "IconButtonWrapper",
    "data-sentry-component": "PlaylistToggle",
    "data-sentry-source-file": "PlaylistToggle.tsx"
  }, /*#__PURE__*/React.createElement(ButtonContainer, {
    onClick: onClick,
    title: "Playlist",
    noMargin: true,
    "data-sentry-element": "ButtonContainer",
    "data-sentry-source-file": "PlaylistToggle.tsx"
  }, /*#__PURE__*/React.createElement(_PlaylistPlayRounded, {
    style: getShadowIconStyles(),
    "data-sentry-element": "PlaylistPlayRounded",
    "data-sentry-source-file": "PlaylistToggle.tsx"
  })), /*#__PURE__*/React.createElement(IconButtonLabel, {
    variant: "body1",
    "data-sentry-element": "IconButtonLabel",
    "data-sentry-source-file": "PlaylistToggle.tsx"
  }, "Playlist"));
};